import React from 'react';
import styled from 'styled-components';

import Layout from 'Templates/Layout';
import ErrorPageImage from 'Assets/Images/img_error_page.png';
import TX from '../Text';

const Fallback = () => (
  <Layout>
    <FallbackContainer>
      <ErrorImage />
      <SubTitle>이전 페이지로 돌아가 다시 시도해 주세요</SubTitle>
    </FallbackContainer>
  </Layout>
);

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  align-items: center;
  justify-content: center;
`;

const ErrorImage = styled.img.attrs({
  src: ErrorPageImage,
  alt: '에러',
})`
  width: 236px;
  height: 170px;
  -webkit-user-drag: none;

  margin-bottom: 32px;
`;

const SubTitle = styled(TX.FootnoteM)`
  color: ${({ theme }) => theme.colors.ui_on_3};

  margin-bottom: 59px;
`;

export default Fallback;
